<div class="nes-text-left">
  <nes-link
    data-pw="customer-requirements__link-to-terms"
    class="nes-mr-5"
    stand-alone
    (click)="openTermsAndConditions()"
    relay42
  >
    {{ 'REQUIREMENTS' | translate }}
  </nes-link>
  <nes-link
    data-pw="customer-requirements__link-to-privacy"
    class="nes-mr-5"
    stand-alone
    (click)="openPrivacy()"
    relay42
  >
    {{ 'PRIVACY' | translate }}
  </nes-link>
  <nes-link
    data-pw="customer-requirements__link-to-customer-service"
    stand-alone
    (click)="openCustomerService()"
    relay42
  >
    {{ 'CUSTOMER_SERVICE' | translate }}
  </nes-link>
</div>
